export default function padZero(value: number | string, minLength = 2): string {
  value = '' + value;
  while (value.length < minLength) {
    value = '0' + value;
  }
  return value;
}
